document.addEventListener("DOMContentLoaded", () => {
  // =====================================================
  // Helpers
  // =====================================================

  const EXTERNAL_WARNING =
    "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      const linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch {
      return false;
    }
  }

  //   function toggleMenu(item) {
  //   const dropdown = item.querySelector(":scope > a");
  //   if (!dropdown) return;

  //   const isOpen = dropdown.getAttribute("aria-expanded") === "true";

  //   if (isOpen) {
  //     dropdown.setAttribute("aria-expanded", "false");
  //     item.classList.remove("active");
  //   } else {
  //     dropdown.setAttribute("aria-expanded", "true");
  //     item.classList.add("active");
  //   }
  // }

  // =====================================================
  // External Link Warnings
  // =====================================================

  function handleExternalLinks() {
    document.querySelectorAll("a").forEach((link) => {
      const href = link.getAttribute("href");
      if (!href || !isThirdParty(href)) return;

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      const img = link.querySelector("img");

      if (img) {
        link.removeAttribute("aria-label");

        let alt = img.getAttribute("alt") || "";
        if (!alt.includes(EXTERNAL_WARNING)) {
          img.setAttribute(
            "alt",
            alt ? alt + ", " + EXTERNAL_WARNING : EXTERNAL_WARNING,
          );
        }
        return;
      }

      const text = link.textContent.trim();
      if (!text) return;

      const aria = link.getAttribute("aria-label");
      if (!aria || !aria.includes(EXTERNAL_WARNING)) {
        link.setAttribute("aria-label", text + ", " + EXTERNAL_WARNING);
      }
    });
  }

  setTimeout(handleExternalLinks, 500);

  // =====================================================
  // Cart Accessibility
  // =====================================================

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;

    const cartClose = document.querySelector(".cart-close");
    if (!(cartClose instanceof HTMLElement)) return;

    cartClose.click();
  });

  document.addEventListener("click", (e) => {
    if (!(e.target instanceof Element)) return;

    // Cart opened -> focus close button
    if (e.target.closest(".header-cart-button")) {
      setTimeout(() => {
        const cartCloseBtn = document.querySelector(".cart-close");
        if (cartCloseBtn instanceof HTMLElement) cartCloseBtn.focus();
      }, 100);
    }

    // Cart closed -> focus back to header cart button
    if (e.target.closest(".cart-close")) {
      setTimeout(() => {
        const headerCartBtn = document.querySelector(".header-cart-button");
        if (headerCartBtn instanceof HTMLElement) {
          headerCartBtn.focus({ preventScroll: true });
        }
      }, 100);
    }
  });

  // =====================================================
  // Back to Top
  // =====================================================

  const backToTopButton = document.getElementById("back-to-top");
  if (backToTopButton) {
    window.addEventListener("scroll", () => {
      backToTopButton.style.display =
        window.pageYOffset > 300 ? "block" : "none";
    });

    backToTopButton.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        const headerLink = document.getElementById("backtoheader");
        if (headerLink instanceof HTMLElement) headerLink.focus();
      }, 600);
    });
  }

  // =====================================================
  // Main Navigation (Dropdowns)
  // =====================================================

  // function toggleMenu(item) {
  //   const dropdown = item.querySelector("a");
  //   if (!dropdown) return;

  //   if (dropdown.getAttribute("aria-expanded") === "false") {
  //     // Close all other menus
  //     document
  //       .querySelectorAll("li.has-children > a")
  //       .forEach((link) => link.setAttribute("aria-expanded", "false"));
  //     document
  //       .querySelectorAll("li.has-children")
  //       .forEach((li) => li.classList.remove("active"));

  //     // Open this menu
  //     dropdown.setAttribute("aria-expanded", "true");
  //     item.classList.add("active");
  //   } else {
  //     dropdown.setAttribute("aria-expanded", "false");
  //     item.classList.remove("active");
  //   }
  // }
  // const navLinks = document.querySelectorAll(
  //   ".main_nav__link-items ul.nav-item__primary-list li.has-children > a"
  // );

  // navLinks.forEach((link) => {
  //   link.removeAttribute("href");
  //   link.setAttribute("role", "button");
  //   link.setAttribute("tabindex", "0");
  //   link.setAttribute("aria-expanded", "false");
  // });

  // const navItems = document.querySelectorAll(
  //   ".main_nav__link-items ul.nav-item__primary-list li.has-children"
  // );

  // // Store last focused trigger for Escape handling
  // let lastFocusedMenuTrigger = null;

  // navLinks.forEach((link) => {
  //   link.addEventListener("click", () => {
  //     lastFocusedMenuTrigger = link;
  //   });
  // });

  // navItems.forEach((item) => {
  //   item.addEventListener("click", (e) => {
  //     e.stopPropagation();
  //     toggleMenu(item);
  //   });

  //   item.addEventListener("keydown", (e) => {
  //     if (e.key !== "Enter") return;
  //     e.preventDefault();
  //     e.stopPropagation();
  //     toggleMenu(item);
  //   });
  // });

  // // Close menu with Escape
  // document.addEventListener("keydown", (e) => {
  //   if (e.key !== "Escape") return;

  //   document
  //     .querySelectorAll("li.has-children > a")
  //     .forEach((link) => link.setAttribute("aria-expanded", "false"));
  //   document
  //     .querySelectorAll("li.has-children")
  //     .forEach((li) => li.classList.remove("active"));

  //   if (lastFocusedMenuTrigger) {
  //     lastFocusedMenuTrigger.focus();
  //   }
  // });
  // // =====================================================
  // // Close Mega Menu on Outside Click / Scroll
  // // =====================================================

  // function hasActiveMenu() {
  //   return document.querySelector("li.has-children.active") !== null;
  // }

  // function closeAllNavMenus() {
  //   document
  //     .querySelectorAll("li.has-children > a")
  //     .forEach((link) => link.setAttribute("aria-expanded", "false"));
  //   document
  //     .querySelectorAll("li.has-children")
  //     .forEach((li) => li.classList.remove("active"));
  // }

  // // Click outside the menu boundary closes it
  // function handleOutsideMenuInteraction(e) {
  //   if (!hasActiveMenu()) return;
  //   if (!(e.target instanceof Element)) return;

  //   const clickedInsideNav = e.target.closest("li.has-children");
  //   if (!clickedInsideNav) {
  //     closeAllNavMenus();
  //   }
  // }

  // document.addEventListener("click", handleOutsideMenuInteraction);
  // document.addEventListener("touchstart", handleOutsideMenuInteraction, {
  //   passive: true,
  // });

  // // Scroll closes the open menu
  // let navScrollTicking = false;
  // window.addEventListener(
  //   "scroll",
  //   () => {
  //     if (!hasActiveMenu()) return;

  //     if (!navScrollTicking) {
  //       window.requestAnimationFrame(() => {
  //         closeAllNavMenus();
  //         navScrollTicking = false;
  //       });
  //       navScrollTicking = true;
  //     }
  //   },
  //   { passive: true }
  // );

  // ===========================================
  // Accessible Desktop Mega Menu
  // ===========================================
  // =====================================================
  // Accessible Desktop Mega Menu
  // =====================================================

  // const menuItems = document.querySelectorAll(
  //   ".main_nav__link-items .nav-item__primary-list > li.has-children"
  // );

  // let activeTrigger = null;

  // function getTrigger(item) {
  //   return item.querySelector(":scope > a");
  // }

  // function getMegaMenu(item) {
  //   return item.querySelector(".mega-menu");
  // }

  // function getFocusableItems(item) {
  //   return item.querySelectorAll(
  //     ".mega-menu a[href], .mega-menu button:not([disabled]), .mega-menu input:not([disabled]), .mega-menu select:not([disabled]), .mega-menu textarea:not([disabled])"
  //   );
  // }

  // /**
  //  * Synchronize accessibility state of the mega menu.
  //  */
  // function updateMegaMenuAccessibility(item, isOpen) {
  //   const megaMenu = getMegaMenu(item);

  //   if (!megaMenu) return;

  //   megaMenu.setAttribute("aria-hidden", String(!isOpen));

  //   const interactiveElements = megaMenu.querySelectorAll(
  //     "a, button, input, select, textarea"
  //   );

  //   interactiveElements.forEach((element) => {
  //     element.tabIndex = isOpen ? 0 : -1;
  //   });
  // }

  // function closeAllMenus() {
  //   menuItems.forEach((item) => {
  //     item.classList.remove("active");

  //     const trigger = getTrigger(item);

  //     if (trigger) {
  //       trigger.setAttribute("aria-expanded", "false");
  //     }

  //     updateMegaMenuAccessibility(item, false);
  //   });
  // }

  // function openMenu(item) {
  //   closeAllMenus();

  //   item.classList.add("active");

  //   const trigger = getTrigger(item);

  //   if (trigger) {
  //     trigger.setAttribute("aria-expanded", "true");
  //     activeTrigger = trigger;
  //   }

  //   updateMegaMenuAccessibility(item, true);

  //   requestAnimationFrame(() => {
  //     const focusables = getFocusableItems(item);

  //     if (focusables.length) {
  //       focusables[0].focus();
  //     }
  //   });
  // }

  // // Initial setup
  // menuItems.forEach((item) => {
  //   const trigger = getTrigger(item);

  //   if (!trigger) return;

  //   trigger.removeAttribute("href");
  //   trigger.setAttribute("role", "button");
  //   trigger.setAttribute("tabindex", "0");
  //   trigger.setAttribute("aria-haspopup", "true");
  //   trigger.setAttribute("aria-expanded", "false");

  //   updateMegaMenuAccessibility(item, false);

  //   // Click
  //   trigger.addEventListener("click", (e) => {
  //     e.preventDefault();
  //     e.stopPropagation();

  //     if (item.classList.contains("active")) {
  //       closeAllMenus();
  //     } else {
  //       openMenu(item);
  //     }
  //   });

  //   // Keyboard
  //   trigger.addEventListener("keydown", (e) => {
  //     switch (e.key) {
  //       case "Enter":
  //       case " ":
  //         e.preventDefault();

  //         if (item.classList.contains("active")) {
  //           closeAllMenus();
  //         } else {
  //           openMenu(item);
  //         }
  //         break;

  //       case "ArrowDown":
  //         e.preventDefault();

  //         if (!item.classList.contains("active")) {
  //           openMenu(item);
  //         }
  //         break;

  //       case "Escape":
  //         e.preventDefault();
  //         closeAllMenus();
  //         trigger.focus();
  //         break;
  //     }
  //   });
  // });

  // // Escape anywhere
  // document.addEventListener("keydown", (e) => {
  //   if (e.key !== "Escape") return;

  //   if (document.querySelector(".nav-item__primary-list li.active")) {
  //     closeAllMenus();

  //     if (activeTrigger) {
  //       activeTrigger.focus();
  //     }
  //   }
  // });

  // // Close on outside click
  // document.addEventListener("click", (e) => {
  //   if (!e.target.closest(".main_nav__link-items")) {
  //     closeAllMenus();
  //   }
  // });

  // // Close on scroll
  // window.addEventListener(
  //   "scroll",
  //   () => {
  //     if (document.querySelector(".nav-item__primary-list li.active")) {
  //       closeAllMenus();
  //     }
  //   },
  //   { passive: true }
  // );
  // ==========================================
  // Desktop Mega Menu Accessibility
  // ==========================================

  // const navItems = document.querySelectorAll(
  //   ".main_nav__link-items .nav-item__primary-list > li.has-children"
  // );

  // const navLinks = document.querySelectorAll(
  //   ".main_nav__link-items .nav-item__primary-list > li.has-children > a"
  // );

  // let lastFocusedTrigger = null;

  // // Setup triggers
  // navLinks.forEach((link) => {
  //   link.removeAttribute("href");
  //   link.setAttribute("role", "button");
  //   link.setAttribute("tabindex", "0");
  //   link.setAttribute("aria-expanded", "false");
  // });

  // // Close all menus
  // function closeAllMenus() {
  //   navItems.forEach((item) => {
  //     item.classList.remove("active");

  //     const trigger = item.querySelector(":scope > a");
  //     if (trigger) {
  //       trigger.setAttribute("aria-expanded", "false");
  //     }
  //   });
  // }

  // // Open menu
  // function openMenu(item) {
  //   closeAllMenus();

  //   const trigger = item.querySelector(":scope > a");

  //   if (!trigger) return;

  //   trigger.setAttribute("aria-expanded", "true");
  //   item.classList.add("active");

  //   // Wait for CSS class to apply
  //   setTimeout(() => {
  //     const firstFocusable =
  //       item.querySelector(
  //         '.mega-menu__third-level-link > a:not([aria-hidden="true"])'
  //       ) ||
  //       item.querySelector(
  //         '.mega-menu__second-level-link > a:not(.visibility-hidden):not([aria-hidden="true"])'
  //       ) ||
  //       item.querySelector(
  //         '.mega-menu a:not(.visibility-hidden):not([aria-hidden="true"])'
  //       ) ||
  //       item.querySelector(".mega-menu button");

  //     if (firstFocusable) {
  //       firstFocusable.focus();
  //     }
  //   }, 50);
  // }

  // // Events
  // navItems.forEach((item) => {
  //   const trigger = item.querySelector(":scope > a");

  //   trigger.addEventListener("click", (e) => {
  //     e.preventDefault();
  //     e.stopPropagation();

  //     lastFocusedTrigger = trigger;

  //     const expanded =
  //       trigger.getAttribute("aria-expanded") === "true";

  //     if (expanded) {
  //       closeAllMenus();
  //       trigger.focus();
  //     } else {
  //       openMenu(item);
  //     }
  //   });

  //   trigger.addEventListener("keydown", (e) => {
  //     if (e.key === "Enter" || e.key === " ") {
  //       e.preventDefault();
  //       trigger.click();
  //     }
  //   });
  // });

  // // Escape
  // document.addEventListener("keydown", (e) => {
  //   if (e.key !== "Escape") return;

  //   closeAllMenus();

  //   if (lastFocusedTrigger) {
  //     lastFocusedTrigger.focus();
  //   }
  // });

  // // Outside click
  // document.addEventListener("click", (e) => {
  //   if (!e.target.closest(".main_nav__link-items")) {
  //     closeAllMenus();
  //   }
  // });

  // // Scroll closes menu
  // window.addEventListener(
  //   "scroll",
  //   () => {
  //     closeAllMenus();
  //   },
  //   { passive: true }
  // );

  // #####

  //  const navItems = document.querySelectorAll(
  //     ".main_nav__link-items .nav-item__primary-list > li.has-children"
  //   );

  //   const navLinks = document.querySelectorAll(
  //     ".main_nav__link-items .nav-item__primary-list > li.has-children > a"
  //   );

  //   let lastFocusedTrigger = null;

  //   // Setup triggers
  //   navLinks.forEach((link) => {
  //     link.removeAttribute("href");
  //     link.setAttribute("role", "button");
  //     link.setAttribute("tabindex", "0");
  //     link.setAttribute("aria-expanded", "false");
  //   });

  //   /**
  //    * Toggle aria-hidden / tabindex on everything inside a mega menu so it's
  //    * only reachable by keyboard / screen readers while its parent menu is
  //    * actually open. The Liquid template ships these links with
  //    * aria-hidden="true" and tabindex="-1" by default, so this MUST run
  //    * before we try to .focus() anything inside the menu, or the focus call
  //    * silently no-ops.
  //    */
  //   function setMenuInertState(item, isOpen) {
  //     const focusables = item.querySelectorAll(".mega-menu a, .mega-menu button");

  //     focusables.forEach((el) => {
  //       if (isOpen) {
  //         el.removeAttribute("aria-hidden");
  //         el.setAttribute("tabindex", "0");
  //       } else {
  //         el.setAttribute("aria-hidden", "true");
  //         el.setAttribute("tabindex", "-1");
  //       }
  //     });
  //   }

  //   // Close all menus
  //   function closeAllMenus() {
  //     navItems.forEach((item) => {
  //       item.classList.remove("active");

  //       const trigger = item.querySelector(":scope > a");
  //       if (trigger) {
  //         trigger.setAttribute("aria-expanded", "false");
  //       }

  //       setMenuInertState(item, false);
  //     });
  //   }

  //   // Open menu
  //   function openMenu(item) {

  //     closeAllMenus();

  //     const trigger = item.querySelector(":scope > a");

  //     if (!trigger) return;

  //     trigger.setAttribute("aria-expanded", "true");
  //     item.classList.add("active");
  //     setMenuInertState(item, true);

  //     // Wait for CSS class / transition to apply before focusing.
  //     // IMPORTANT: second-level links must be checked BEFORE third-level ones.
  //     // Third-level links exist in the DOM as soon as the menu opens (they're
  //     // just visually collapsed inside a nested accordion), so checking them
  //     // first would always steal focus away from the top-level "Featured"
  //     // style links the person actually lands on first.
  //     setTimeout(() => {
  //       const firstFocusable =
  //         item.querySelector(
  //           '.mega-menu__second-level-link > a:not(.visibility-hidden)'
  //         ) ||
  //         item.querySelector(
  //           '.mega-menu__third-level-link > a:not(.visibility-hidden)'
  //         ) ||
  //         item.querySelector('.mega-menu a:not(.visibility-hidden)') ||
  //         item.querySelector(".mega-menu button");

  //       if (firstFocusable instanceof HTMLElement) {
  //         firstFocusable.focus();
  //       }
  //     }, 50);
  //   }

  //   // Events
  //   navItems.forEach((item) => {
  //     const trigger = item.querySelector(":scope > a");
  //     if (!trigger) return;

  //     trigger.addEventListener("click", (e) => {
  //       e.preventDefault();
  //       e.stopPropagation();

  //       lastFocusedTrigger = trigger;

  //       const expanded = trigger.getAttribute("aria-expanded") === "true";

  //       if (expanded) {
  //         closeAllMenus();
  //         trigger.focus();
  //       } else {
  //         openMenu(item);
  //       }
  //     });

  //     trigger.addEventListener("keydown", (e) => {
  //       if (e.key === "Enter" || e.key === " ") {
  //         e.preventDefault();
  //         trigger.click();
  //       }
  //     });
  //   });

  //   // Escape closes menu + returns focus to the trigger that opened it
  //   document.addEventListener("keydown", (e) => {
  //     if (e.key !== "Escape") return;

  //     closeAllMenus();

  //     if (lastFocusedTrigger) {
  //       lastFocusedTrigger.focus();
  //     }
  //   });

  //   // Outside click closes menu.
  //   // Track the actual open <li> rather than just "inside the nav wrapper" —
  //   // that way a click anywhere else on the page (header logo, search, cart,
  //   // page body, etc.) reliably closes the open dropdown, not just clicks
  //   // outside the primary nav list specifically.
  //   document.addEventListener("click", (e) => {
  //     if (!(e.target instanceof Element)) return;

  //     const openItem = document.querySelector("li.has-children.active");
  //     if (!openItem) return;

  //     if (!openItem.contains(e.target)) {
  //       closeAllMenus();
  //     }
  //   });

  //   // Scroll closes menu (only does work if something is actually open)
  //   window.addEventListener(
  //     "scroll",
  //     () => {
  //       if (!document.querySelector("li.has-children.active")) return;
  //       closeAllMenus();
  //     },
  //     { passive: true }
  //   );

  // ==========================================
  // Mobile Navigation Accordion
  // ==========================================

  //              =============   Simplest js working
  //  const links = document.querySelectorAll(
  //   ".nav-item__primary-list li.has-children > a, " +
  //   ".mega-menu__second-level-link > a[data-sublink-toggle]"
  // );

  // links.forEach((link) => {
  //   link.removeAttribute("href");
  //   link.setAttribute("role", "button");
  //   link.setAttribute("tabindex", "0");

  //   if (!link.hasAttribute("aria-expanded")) {
  //     link.setAttribute("aria-expanded", "false");
  //   }

  //   function toggleExpanded(e) {
  //     e.preventDefault();

  //     const expanded = link.getAttribute("aria-expanded") === "true";

  //     link.setAttribute("aria-expanded", String(!expanded));
  //   }

  //   link.addEventListener("click", toggleExpanded);

  //   link.addEventListener("keydown", (e) => {
  //     if (e.key === "Enter" || e.key === " ") {
  //       toggleExpanded(e);
  //     }
  //   });
  // });
  function updateDesktopClass() {
    document.querySelectorAll(".main_nav__link-items").forEach((element) => {
      if (window.matchMedia("(min-width: 1025px)").matches) {
        element.classList.add("desktop-only");
      } else {
        element.classList.add("mobile-only");
      }
    });
  }

  updateDesktopClass();
  window.addEventListener("resize", updateDesktopClass);
  // Convert menu links into buttons

  document.querySelectorAll(".desktop-only ul.nav-item__primary-list li.has-children > a, .mobile-only ul.nav-item__primary-list li.has-children > a").forEach((link) => {
  link.removeAttribute("href");
  link.setAttribute("role", "button");
  link.setAttribute("tabindex", "0");
  link.setAttribute("aria-expanded", "false");
});

document
  .querySelectorAll(
    ".mobile-only ul.nav-item__primary-list li.has-children .mega-menu"
  )
  .forEach((menu) => {
    menu.setAttribute("role", "dialog");
    menu.setAttribute("aria-modal", "true");
    menu.setAttribute("tabindex", "0");
  });

  // Toggle mega menu

  // document.querySelectorAll(".desktop-only ul.nav-item__primary-list li.has-children")

  //   .forEach((item) => {
  //     item.addEventListener("click", toggleMenu);

  //     item.addEventListener("keypress", toggleMenu);
  //   });

  // function toggleMenu(e) {
  //   e.stopPropagation();

  //   if (e.type === "keypress" && e.key !== "Enter") {
  //     return;
  //   }

  //   const dropdown = this.querySelector("a");

  //   if (dropdown.getAttribute("aria-expanded") === "false") {
  //     document

  //       .querySelectorAll("li.has-children > a")

  //       .forEach((link) => {
  //         link.setAttribute("aria-expanded", "false");
  //       });

  //     document

  //       .querySelectorAll("li.has-children")

  //       .forEach((item) => {
  //         item.classList.remove("active");
  //       });

  //     dropdown.setAttribute("aria-expanded", "true");

  //     this.classList.add("active");
  //   } else {
  //     dropdown.setAttribute("aria-expanded", "false");

  //     this.classList.remove("active");
  //   }
  // }

  // // Store last focused trigger

  // let lastFocusedMenuTrigger = null;

  // document.querySelectorAll("li.has-children > a").forEach((link) => {
  //   link.addEventListener("click", function () {
  //     lastFocusedMenuTrigger = this;
  //   });
  // });

  // // Close menu on Escape

  // document.addEventListener("keydown", function (e) {
  //   if (e.key === "Escape") {
  //     document

  //       .querySelectorAll("li.has-children > a")

  //       .forEach((link) => {
  //         link.setAttribute("aria-expanded", "false");
  //       });

  //     document

  //       .querySelectorAll("li.site-nav__item-normal")

  //       .forEach((item) => {
  //         item.classList.remove("active");
  //       });

  //     if (lastFocusedMenuTrigger) {
  //       lastFocusedMenuTrigger.focus();
  //     }
  //   }
  // });

(function () {
  "use strict";

  const DESKTOP_WIDTH = 1025;

  function syncAriaExpanded() {
    document.querySelectorAll("[data-sublink-toggle]").forEach((trigger) => {
      trigger.setAttribute(
        "aria-expanded",
        trigger.classList.contains("active") ? "true" : "false"
      );
    });

    document.querySelectorAll("[data-toggle-mobile-menu]").forEach((btn) => {
      btn.setAttribute(
        "aria-expanded",
        document.body.classList.contains("mobile-menu--is-open")
          ? "true"
          : "false"
      );
    });
  }

  // Close all desktop menus except the clicked one
  function closeOtherDesktopMenus(currentTrigger) {
    document
      .querySelectorAll("[data-sublink-toggle].active")
      .forEach((trigger) => {
        if (trigger !== currentTrigger) {
          trigger.classList.remove("active");
          trigger.setAttribute("aria-expanded", "false");
        }
      });

    document
      .querySelectorAll("[data-mega-menu-id].active")
      .forEach((menu) => {
        const menuId = currentTrigger.getAttribute("data-sublink-toggle");

        if (!menuId || menu.id !== menuId) {
          menu.classList.remove("active");
        }
      });
  }

  function closeDesktopMenus() {
    document
      .querySelectorAll("[data-sublink-toggle].active")
      .forEach((trigger) => {
        trigger.classList.remove("active");
        trigger.setAttribute("aria-expanded", "false");
      });

    document
      .querySelectorAll("[data-mega-menu-id].active")
      .forEach((menu) => {
        menu.classList.remove("active");
      });

    syncAriaExpanded();
  }

  function closeMobileMenu() {
    if (!document.body.classList.contains("mobile-menu--is-open")) {
      return;
    }

    const closeBtn = document.querySelector("[data-presented-close-menu]");

    if (closeBtn) {
      closeBtn.click();
    } else {
      document.body.classList.remove("mobile-menu--is-open");
    }

    syncAriaExpanded();
  }

  /*
   * IMPORTANT:
   * Capture phase runs before the theme's click handler.
   * We close the previously open menu, then allow the
   * theme's normal click handler to open the clicked menu.
   */
  document.addEventListener(
    "click",
    function (e) {
      if (window.innerWidth <= DESKTOP_WIDTH) return;

      const trigger = e.target.closest("[data-sublink-toggle]");

      if (!trigger) return;

      closeOtherDesktopMenus(trigger);

      // Let the theme handle opening the clicked menu.
      setTimeout(syncAriaExpanded, 0);
    },
    true
  );

  // ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;

    if (window.innerWidth > DESKTOP_WIDTH) {
      closeDesktopMenus();
    } else {
      closeMobileMenu();
    }
  });

  // Outside click - Desktop only
  document.addEventListener("click", function (e) {
    if (window.innerWidth <= DESKTOP_WIDTH) return;

    if (
      !e.target.closest(".main_nav__link-items") &&
      !e.target.closest("[data-mega-menu-id]")
    ) {
      closeDesktopMenus();
    }
  });

  // Close on scroll - Desktop only
  window.addEventListener("scroll", function () {
    if (window.innerWidth > DESKTOP_WIDTH) {
      closeDesktopMenus();
    }
  });

  // Keep aria-expanded in sync
  const observer = new MutationObserver(function () {
    syncAriaExpanded();
  });

  window.addEventListener("load", function () {
    syncAriaExpanded();

    document
      .querySelectorAll("[data-sublink-toggle], [data-toggle-mobile-menu]")
      .forEach((el) => {
        observer.observe(el, {
          attributes: true,
          attributeFilter: ["class"],
        });
      });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  });
})();


  

//   (function () {
//   "use strict";

//   const DESKTOP_WIDTH = 1025;

//   // Update aria-expanded based on active class
//   function syncAriaExpanded() {
//     document.querySelectorAll("[data-sublink-toggle]").forEach((trigger) => {
//       trigger.setAttribute(
//         "aria-expanded",
//         trigger.classList.contains("active") ? "true" : "false"
//       );
//     });

//     document.querySelectorAll("[data-toggle-mobile-menu]").forEach((btn) => {
//       btn.setAttribute(
//         "aria-expanded",
//         document.body.classList.contains("mobile-menu--is-open")
//           ? "true"
//           : "false"
//       );
//     });
//   }

//   // Close desktop menus
//   function closeDesktopMenus() {
//     document.querySelectorAll("[data-sublink-toggle].active").forEach((trigger) => {
//       trigger.classList.remove("active");
//       trigger.setAttribute("aria-expanded", "false");
//     });

//     document.querySelectorAll("[data-mega-menu-id].active").forEach((menu) => {
//       menu.classList.remove("active");
//     });
//   }

//   // Close mobile menu
//   function closeMobileMenu() {
//     if (!document.body.classList.contains("mobile-menu--is-open")) return;

//     const closeBtn = document.querySelector("[data-presented-close-menu]");

//     if (closeBtn) {
//       closeBtn.click(); // Uses existing theme logic
//     } else {
//       document.body.classList.remove("mobile-menu--is-open");
//     }

//     syncAriaExpanded();
//   }

//   // ESC key
//   document.addEventListener("keydown", function (e) {
//     if (e.key !== "Escape") return;

//     if (window.innerWidth > DESKTOP_WIDTH) {
//       closeDesktopMenus();
//     } else {
//       closeMobileMenu();
//     }
//   });

  
//   // Outside click (Desktop only)
//   document.addEventListener("click", function (e) {
//     if (window.innerWidth <= DESKTOP_WIDTH) return;

//     if (
//       !e.target.closest(".main_nav__link-items") &&
//       !e.target.closest("[data-mega-menu-id]")
//     ) {
//       closeDesktopMenus();
//     }
//   });

//   // Close on scroll (Desktop only)
//   window.addEventListener("scroll", function () {
//     if (window.innerWidth > DESKTOP_WIDTH) {
//       closeDesktopMenus();
//     }
//   });


//   // Keep aria-expanded in sync with theme
//   const observer = new MutationObserver(syncAriaExpanded);

//   window.addEventListener("load", function () {
//     syncAriaExpanded();

//     document
//       .querySelectorAll("[data-sublink-toggle], [data-toggle-mobile-menu]")
//       .forEach((el) => {
//         observer.observe(el, {
//           attributes: true,
//           attributeFilter: ["class"],
//         });
//       });

//     observer.observe(document.body, {
//       attributes: true,
//       attributeFilter: ["class"],
//     });
//   });
// })();
});
